import React from 'react';
import styles from './layout.module.css';

const Layout=(props)=>{
	let empty=(<div className={styles.empty}/>),
		children=[0,1,2,3].map(position=>props.children[position+props.increment]!==undefined
			?(<div className={styles.content}>
				{React.cloneElement(props.children[position+props.increment],{author:false,image_type:(position%2===0?'SQUARE':'CLOSE'),layout_styles:{title_container:styles.title_container}})}
			</div>)
			:undefined);
			
  return (
	<div className={styles.container}>		
		<div className={[styles.left,children[2]===undefined && children[3]===undefined?styles.empty_right:null].join(' ')}>
			{children[0] || empty}
			{children[1] || empty}
		</div>
		<div className={[styles.right,children[2]===undefined && children[3]===undefined?styles.empty_right:null].join(' ')}>
			{children[2] || empty}
			{children[3] || empty}
		</div>
    </div>
  );
};

export default Layout;
